import type { Theme } from '../types';

// Pastel — calm warm gradient, no decoration. Ships intentionally
// motion-light for kids who find the busy themes overstimulating.
export const pastelTheme: Theme = {
  key: 'pastel',
  name: 'Pastelli',
  tokens: {
    bodyBackground: 'linear-gradient(180deg, #fef3c7 0%, #fde68a 45%, #fbcfe8 100%)',
    pageHeadingColor: '#7c2d12',
    pageHeadingShadow: '0 3px 0 rgba(255, 255, 255, 0.55)',
    routineCardSurface: 'rgba(255, 255, 255, 0.65)',
    cardSurface: 'rgba(255, 255, 255, 0.85)',
    accent: '#f59e0b',
  },
  routineCardPalette: ['#fcd34d', '#86efac', '#a5b4fc', '#fda4af', '#fdba74', '#bef264'],
};
